window.initializeInteractiveMapComponent = function (elem) {
    const stops = elem.data('stops');
    mapboxgl.accessToken = elem.data('access-token');

    let longitudeArr = [];
    let latitudeArr = [];
    let centerLongitude = 0;
    let centerLatitude = 0;
    let stopsFeatures = {
        type: 'FeatureCollection',
        features: []
    };

    for (const stopsKey in stops) {
        if (!stops.hasOwnProperty(stopsKey)) {
            continue;
        }

        stopsFeatures.features.push({
            type: 'Feature',
            geometry: {
                coordinates: [stops[stopsKey]['longitude'], stops[stopsKey]['latitude']],
                type: "Point"
            }
        })

        longitudeArr.push(stops[stopsKey]['longitude']);
        latitudeArr.push(stops[stopsKey]['latitude']);
    }

    const average = arr => arr.reduce((a, b) => a + b, 0) / arr.length;
    centerLongitude = average(longitudeArr) ? average(longitudeArr) : longitudeArr[0];
    centerLatitude = average(latitudeArr) ? average(latitudeArr) : latitudeArr[0];

    const link = elem.data('link');
    const map = new mapboxgl.Map({
        container: elem.attr('id'),
        style: 'mapbox://styles/mapbox/streets-v11',
        zoom: 4,
        center: [centerLongitude, centerLatitude]
    });

    async function getDirectionsForMap() {
        const query = await fetch(link, {method: 'GET'});
        const json = await query.json();

        if (json.routes === undefined) {
            return [];
        }

        return json.routes[0] !== undefined ? json.routes[0].geometry.coordinates : [];
    }

    map.on('load', () => {
        getDirectionsForMap().then(function (route) {
            if (route.length === 0) {
                return;
            }

            const directionLineFeature = {
                type: 'Feature',
                properties: {},
                geometry: {
                    type: 'LineString',
                    coordinates: route
                }
            };

            if (map.getSource('route')) {
                map.getSource('route').setData(directionLineFeature);
            } else {
                map.addLayer({
                    id: 'route',
                    type: 'line',
                    source: {
                        type: 'geojson',
                        data: directionLineFeature
                    },
                    layout: {
                        'line-join': 'round',
                        'line-cap': 'round'
                    },
                    paint: {
                        'line-color': '#3887be',
                        'line-width': 5,
                        'line-opacity': 0.75
                    }
                });
            }
        });
        map.addSource('stops', {
            type: 'geojson',
            data: stopsFeatures
        });

        map.addLayer({
            'id': 'stops-layer',
            'type': 'circle',
            'source': 'stops',
            'paint': {
                'circle-radius': 8,
                'circle-stroke-width': 2,
                'circle-color': 'blue',
                'circle-stroke-color': 'white'
            }
        });

        var margin = 0.2;
        map.fitBounds([
            [Math.min(...longitudeArr) - margin, Math.min(...latitudeArr) - margin], // southwestern corner of the bounds
            [Math.max(...longitudeArr) + margin, Math.max(...latitudeArr) + margin] // northeastern corner of the bounds
        ]);

    });
}

$('.interactive-map-component').each(function (k, i) {
    window.initializeInteractiveMapComponent($(i));
});
